import { render, staticRenderFns } from "./Distributions.vue?vue&type=template&id=7af6fcc5&"
import script from "./Distributions.vue?vue&type=script&lang=js&"
export * from "./Distributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports